// @flow strict

import React from "react";
import { withRouter } from "react-router-dom";
import type { ContextRouter, RouterHistory } from "react-router-dom";
import { AVATAR_PLAYER, NAME_PLAYER, PATHS } from "~robin-hood/utils";
import type { Player } from "~robin-hood/utils";
import { InFrame } from "~robin-hood/Frame";
import styles from "./SeleccionAgentes.module.css";
import type { RegisteredStore, Agent, Equipo } from "~robin-hood/redux/store";
import { getAgentPlayers } from "~robin-hood/redux/store";

type Props = {
  agent: Agent,
  history: RouterHistory,
  equipo: Equipo,
  store: RegisteredStore,
  updateLocalStore: (RegisteredStore) => void,
};

export class SeleccionAgentes extends React.PureComponent<Props> {
  componentDidMount() {
    const { history, equipo, agent } = this.props;
    const players = getAgentPlayers(equipo, agent);
    if (players.length === 1) {
      history.push(PATHS.INICIAL(players[0]));
    }
  }

  render(): React$Node {
    const { equipo, agent } = this.props;
    const players = getAgentPlayers(equipo, agent);
    return (
      <InFrame
        style={{ background: "#090a0a", justifyContent: "center" }}
        noToolbar
      >
        <div className={styles.agentesWrap}>
          <div className={styles.agentesRow}>
            {players.map((player) => (
              <div key={player} className={styles.agentesCol}>
                <AgenteAvatar player={player} />
              </div>
            ))}
          </div>
        </div>
      </InFrame>
    );
  }
}

type AgenteAvatarProps = {
  player: Player,
  ...ContextRouter,
};

class AgenteAvatarClass extends React.PureComponent<AgenteAvatarProps> {
  _onClick = () => {
    const { player, history } = this.props;
    history.push(PATHS.INICIAL(player));
  };

  render() {
    const { player } = this.props;
    return (
      <div className={styles.agente} onClick={this._onClick}>
        <div className={styles.avatar}>
          <div className={styles.avatarWrapper}>
            <img alt="Agente" src={AVATAR_PLAYER.get(player)} />
          </div>
        </div>
        <div className={styles.name}>
          <span>{NAME_PLAYER.get(player)}</span>
        </div>
      </div>
    );
  }
}
const AgenteAvatar = withRouter(AgenteAvatarClass);
